<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTab === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs">
					<a @click.prevent="changeTab(tab.name)" v-if="!tab.disabled"><i :class="tab.icon"></i> {{ tab.displayName }}</a>
				</li>

			</ul>
		</nav>

		<div class="main">
			<provider-list-editor-general
					:data-provider-list="providerList"
					:data-providers="providers"
					:data-types="types"
					v-if="activeTab === 'general'">
			</provider-list-editor-general>

			<provider-list-editor-sharing
					v-if="activeTab === 'sharing'">
			</provider-list-editor-sharing>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataProviderList: {
				type: Object
			},
			dataTypes: {
				type: Object
			},
			dataProviders: {
				type: Array
			}
		},
		data() {
			return {
				providerList: this.dataProviderList,
				types: this.dataTypes,
				providers: this.dataProviders,
				tabs: [
					{
						name: 'general',
						displayName: 'General',
						icon: 'fas fa-cog',
						disabled: false
					},
					{
						name: 'sharing',
						displayName: 'Sharing',
						icon: 'fas fa-share',
						disabled: false
					}
				],

				activeTab: 'general',
			}
		},
		mounted() {
			this.checkUrl();
		},
		methods: {
			changeTab: function (name) {
				this.activeTab = name;
				this.$forceUpdate();
				this.updateUrl();
			},
			checkUrl: function () {
				let tabQuery = this.getParameterByName('tab');

				if (tabQuery !== null) {
					this.activeTab = tabQuery;
				} else {
					this.updateUrl();
				}
			},
			getParameterByName: function (name) {
				var url = window.location.href;
				name = name.replace(/[\[\]]/g, '\\$&');
				var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
					results = regex.exec(url);
				if (!results) return null;
				if (!results[2]) return '';
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			},
			updateUrl: function () {
				let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?tab=' + this.activeTab.toLowerCase();
				window.history.pushState({path: newurl}, '', newurl);
			},
		}
	}

</script>

<style scoped>

</style>
